import { createDecorator } from 'components/form'
import { ListaEsperaMotivoSaidaEnum } from 'graphql/types.generated'
import { MetaPath, MetaRoot } from 'util/metaPath'

import { GarantiaAcessoRemocaoModel } from '../model-garantiaAcesso'

export const createRemocaoCalculations = (
  name: MetaPath<GarantiaAcessoRemocaoModel> | MetaRoot<GarantiaAcessoRemocaoModel>
) =>
  createDecorator({
    field: name.motivoSaida.absolutePath(),
    updates: {
      [name.tentativasContato.absolutePath()]: (
        value: ListaEsperaMotivoSaidaEnum,
        allValues: GarantiaAcessoRemocaoModel
      ) => {
        if (value === ListaEsperaMotivoSaidaEnum.NAO_RESPONDEU_TENTATIVAS_CONTATO) return allValues.tentativasContato
      },
    },
  })
